import { PrintLabelController } from '../../../components/print/print-label.controller';

'use strict';

angular.module('mandaeApp')
  .controller('HistoricoPedidoCtrl', function($rootScope, $scope, $state, $stateParams, $interval, $window, $timeout, Pedido, Historico, NgTableParams, Perfil) {
    $scope.alerts = [];
    $scope.acabouDeFinalizar = $stateParams.acabouDeFinalizar;
    $scope.ultimoPasso = $state.current.name == 'historico.pedido.envio';
    // timer de atualizacao de pagina
    $scope.timer = null;
    // cria a variavel de pedido
    $scope.pedido = null;

    $scope.freedom = Perfil.getCacheUserData().freedom;

    $scope.alerts = [];

    $scope.searching = null;

    $scope.addAlert = function(msg, type) {
      $scope.alerts.push({ msg: msg, type: type });
    };

    $scope.closeAlert = function(index) {
      $scope.alerts.splice(index, 1);
    };

    $rootScope.$on('coleta-atualizada', function() {
      $scope.atualizaOs();
    });

    //        $scope.searchObject = {};
    //        $scope.buscarPor = null;
    $scope.atualizaOs = function() {
      var idPedido = $stateParams.idPedido;
      // chamar o serviço
      $scope.exibirSituacaoPedido(idPedido);
    };

    // retorna 0 se valor for negativo
    $scope.showValue = function(valor) {
      if (valor > 0) {
        return valor;
      } else {
        return 0.00;
      }
    };

    $scope.exibirSituacaoPedido = function(idPedido) {
      Historico.getSituacaoOs(idPedido)
        .then(function(pedido) {
          $scope.pedido = pedido;
          $scope.numeroOS = pedido.numero;
          $scope.veiculo = pedido.veiculo;

          switch (pedido.codigoSituacao) {
            case 'Cancelada':
              $state.go('cancelado');
              break;
            case 'ForaArea':
              $state.go('foraarea');
              break;
            case 'Incompleta':
              $state.go('incompleto');
              break;
            case 'RetiradaAgendada':
            case 'ColaboradorSelecionado':
              $scope.confirmacaoAtivo = 2;
              $state.go('confirmacao');
              break;
            case 'AguardandoColaborador':
              $scope.localizacaoAtivo = 2;
              $scope.confirmacaoAtivo = 3;
              $state.go('localizacao');
              break;
            case 'ACaminhoMandae':
              $scope.retiradaAtivo = 2;
              $scope.confirmacaoAtivo = 3;
              $scope.localizacaoAtivo = 3;
              $state.go('retirada', {
                pedido: pedido
              });
              break;
            case 'ChegouMandae':
              $scope.empacotamentoAtivo = 2;
              $scope.confirmacaoAtivo = 3;
              $scope.localizacaoAtivo = 3;
              $scope.retiradaAtivo = 3;
              $state.go('empacotamento', {
                pedido: pedido
              });
              break;
            case 'Concluida':
              $scope.envioAtivo = 2;
              $scope.confirmacaoAtivo = 3;
              $scope.localizacaoAtivo = 3;
              $scope.retiradaAtivo = 3;
              $scope.empacotamentoAtivo = 3;
              $state.go('envio', {
                pedido: pedido
              });
              break;
          }

        })
        .catch($scope.tratarErrosBackEnd);
    };

    $scope.atualizaOs();

    $scope.timer = $interval(function() {
      $scope.exibirSituacaoPedido($stateParams.idPedido);
    }, 300000);

    $scope.$on("$destroy", function() {
      if ($scope.timer) {
        $interval.cancel($scope.timer);
      }
    })

    $scope.tratarErrosBackEnd = function(err) {
      $scope.errors = {};
      if (err != null && err.erro) {
        $scope.addAlert(err.erro);
      } else if (err != null && err[0] != null) {
        $scope.addAlert(err[0].message || err[0].erro);
      } else if (err.data && err.data.erro) {
        $scope.addAlert(err.data.erro);
      } else if (err.data && err.data.length) {
        for (var erro in err.data) {
          $scope.$emit('erroEncontrado', err.data[erro].message);
        }
      }
    };

  });
